import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { defineMessages, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Icon from '../../components/Icon';
import Message from '../../components/Message';
import './styles.css';

export const messages = defineMessages({
  impersonatorText: {
    id: 'site-header.impersonatorText',
    defaultMessage: 'You\'re currently logged in as {user} from {institution}. Changes you make will reflect in their account.', // eslint-disable-line max-len
  },
});

const ImpersonatorBanner = ({ current }) => {
  const idToken = get(current, 'viewer.idToken');
  if (idToken && idToken.impersonator) {
    return (
      <Message info size="small" icon className="toast persistent" styleName="impersonator-banner">
        <Icon name="exclamation circle" styleName="impersonator-banner-icon" />
        <Message.Content>
          <FormattedMessage
            {...messages.impersonatorText}
            values={{
              user: `${idToken.given_name} ${idToken.family_name}`,
              institution: idToken.institutionName,
            }}
          />
        </Message.Content>
      </Message>
    );
  }
  return null;
};

ImpersonatorBanner.propTypes = {
  current: PropTypes.shape({
    viewer: PropTypes.shape({
      idToken: PropTypes.shape({
        given_name: PropTypes.string,
        family_name: PropTypes.string,
        institutionName: PropTypes.string,
        impersonator: PropTypes.string,
      }),
    }),
  }).isRequired,
};

const mapStateToProps = (state) => ({
  current: state.current,
});

export default connect(mapStateToProps)(ImpersonatorBanner);
